import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Slider from "react-slick";

import banner1 from "../assets/images/banner-bg1.jpg";
import banner2 from "../assets/images/banner-bg2.jpg";
import banner3 from "../assets/images/banner-bg3.jpg";

export default function Hero() {
    const navigate = useNavigate();

    const [destinations, setDestinations] = useState([]);

    const [form, setForm] = useState({
        destination: "",
        checkIn: "",
        checkOut: "",
        guests: 2,
    });

    // ✅ HERO SLIDES (local images)
    const [slides] = useState([banner1, banner2, banner3]);

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        fade: true,
        pauseOnHover: false,
        cssEase: "linear",
    };

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]:
                e.target.name === "guests"
                    ? Number(e.target.value)
                    : e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.destination.trim()) {
            alert("Please select a destination");
            return;
        }

        navigate("/search-hotels", { state: form });
    };

    useEffect(() => {
        api
            .get("/destinations")
            .then((res) => setDestinations(res.data))
            .catch((err) => console.log(err));
    }, []);

    return (
        <section className="relative min-h-[650px] md:min-h-[650px] lg:min-h-[650px] xl:min-h-[650px] overflow-hidden">

            {/* 🔥 BACKGROUND SLIDER */}
            <div className="absolute inset-0 z-0 h-full">
                <Slider className="hero-slider" {...sliderSettings}>
                    {slides.map((img, i) => (
                        <div key={i}>
                            <div
                                className="w-full h-full min-h-[650px] md:min-h-[650px] lg:min-h-[650px] xl:min-h-[650px] bg-cover bg-center"
                                style={{ backgroundImage: `url(${img})` }}
                            />
                        </div>
                    ))}
                </Slider>

                {/* DARK OVERLAY */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#0D132180]/40 via-[#0D1321]/70 to-[#10161F]" />
            </div>

            {/* CONTENT */}
            <div className="relative z-10 container mx-auto px-6 lg:px-10 min-h-[650px] flex items-center pt-14 lg:pt-0">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center w-full justify-items-center lg:justify-items-stretch text-center lg:text-left">

                    {/* TEXT */}
                    <div className="max-w-xl mx-auto lg:mx-0">

                        <p className="uppercase tracking-[0.25em] text-[#D9BB74] text-sm mb-6">
                            EXPERIENCE DUBAI LIKE NEVER BEFORE
                        </p>

                        <h1 className="font-serif text-white text-4xl lg:text-5xl xl:text-6xl leading-[1.15] font-medium">
                            Luxury Hotels,
                            <br />
                            Exclusive
                            <span className="text-[#D9BB74]"> UAE Deals</span>
                            <br />
                            Await You
                        </h1>

                        <p className="mt-8 text-lg leading-8 text-white/75 max-w-[430px] mx-auto lg:mx-0">
                            Explore Dubai's luxury hotels, beachfront resorts, and city escapes.
                            Compare thousands of stays and discover unbeatable hotel offers
                            across the UAE.
                        </p>

                    </div>

                    {/* FORM */}
                    <form
                        onSubmit={handleSubmit}
                        className="relative w-full max-w-[430px] mx-auto lg:ml-auto lg:mr-0"
                    >
                        <div className="relative bg-[#F3E8D3] border border-[#D9BB74] rounded-t-[180px] rounded-b-sm p-6 sm:p-8 lg:p-10 shadow-2xl">

                            {/* Title */}
                            <h3 className="text-center uppercase tracking-[0.18em] text-sm text-[#23473F] font-medium mb-8">
                                Find Your Stay
                            </h3>

                            <div className="space-y-5">

                                {/* Destination */}
                                <div>
                                    <label className="block text-[11px] uppercase tracking-[0.18em] text-gray-500 mb-2">
                                        Destination
                                    </label>

                                    <select
                                        name="destination"
                                        value={form.destination}
                                        onChange={handleChange}
                                        className="w-full rounded-sm border border-gray-300 bg-white px-4 py-3 text-gray-700 focus:border-[#D9BB74] focus:ring-0"
                                    >
                                        <option value="">Where are you headed?</option>

                                        {destinations.map((dest) => (
                                            <option key={dest.id} value={dest.name}>
                                                {dest.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Check In / Check Out */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                                    <div className="min-w-0">
                                        <label className="block text-[11px] uppercase tracking-[0.18em] text-gray-500 mb-2">
                                            Check In
                                        </label>

                                        <input
                                            type="date"
                                            name="checkIn"
                                            value={form.checkIn}
                                            onChange={handleChange}
                                            className="block w-full h-[46px] max-w-full min-w-0 appearance-none rounded-sm border border-gray-300 bg-white px-4 text-gray-700 focus:border-[#D9BB74] focus:ring-0"
                                        />
                                    </div>

                                    <div className="min-w-0">
                                        <label className="block text-[11px] uppercase tracking-[0.18em] text-gray-500 mb-2">
                                            Check Out
                                        </label>

                                        <input
                                            type="date"
                                            name="checkOut"
                                            value={form.checkOut}
                                            onChange={handleChange}
                                            className="block w-full h-[46px] max-w-full min-w-0 appearance-none rounded-sm border border-gray-300 bg-white px-4 text-gray-700 focus:border-[#D9BB74] focus:ring-0"
                                        />
                                    </div>

                                </div>

                                {/* Guests */}
                                <div>
                                    <label className="block text-[11px] uppercase tracking-[0.18em] text-gray-500 mb-2">
                                        Guests
                                    </label>

                                    <select
                                        name="guests"
                                        value={form.guests}
                                        onChange={handleChange}
                                        className="w-full rounded-sm border border-gray-300 bg-white px-4 py-3 text-gray-700 focus:border-[#D9BB74] focus:ring-0"
                                    >
                                        <option value={1}>1 Adult</option>
                                        <option value={2}>2 Adults</option>
                                        <option value={3}>3 Adults</option>
                                        <option value={4}>4 Adults</option>
                                        <option value={5}>Family</option>
                                    </select>
                                </div>

                                {/* Search Button */}
                                <button
                                    type="submit"
                                    className="w-full bg-[#23473F] hover:bg-[#1A352F] text-white uppercase tracking-[0.18em] font-medium py-[15px] rounded-sm transition duration-300"
                                >
                                    Search Hotels
                                </button>

                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}